/* eslint-disable max-len */
import {
  AfterContentInit,
  Component,
  inject,
  OnInit,
} from '@angular/core';

import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

import { PlatformInterface } from '../../../../core/models';


import { EditDspService } from '../../services';
import { MainDashboardInterface } from '../../models';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-dsp-dialog',
  templateUrl: './edit-dsp-dialog.component.html',
  styleUrls: ['./edit-dsp-dialog.component.scss'],
  standalone: false
})
export class EditDspDialogComponent implements OnInit, AfterContentInit {
  protected mraidTooltip = '"Exclude mraid.js responses" filter: mraid.js is contained in the ADM in the DSP response';

  public data = inject(NZ_MODAL_DATA) as MainDashboardInterface.IEditDSPDialog;

  protected androidTooltipUrl = 'https://play.google.com/store/apps/details?id=${app.bundle}';
  protected iosTooltipUrl = 'https://itunes.apple.com/app/id${app.bundle}';

  private macrosListContentHeight = 'auto';
  private macrosListBodyHeight = 'auto';
  protected customSchainSettingsModalWidth = 'auto';

  constructor(
    protected editDspService: EditDspService,
    private dialogRef: NzModalRef<EditDspDialogComponent>,
  ) { }

  public ngOnInit() {
    this.editDspService.initComponent(this.data);

    window.addEventListener('storage', e => {
      if (e.key === 'NODE_ORDER_UPDATE') {
        const stored = localStorage.getItem('NODE_ORDER_UPDATE');
        this.editDspService.schainNodeOrderItems = stored ? JSON.parse(stored) : [];
      }
    });

    (this.editDSPForm.get('isSspSchain') as FormControl).valueChanges.subscribe(value => {
      this.editDspService.onChangeSSPSchainStatusHandler(value);
    });

    (this.editDSPForm.get('sChain') as FormControl).valueChanges.subscribe(value => {
      this.editDspService.onChangePlatformSchainStatusHandler(value);
    });

    (this.editDSPForm.get('schain_source') as FormControl).valueChanges.subscribe(value => {
      this.editDspService.onChangeDSPSourceSchainStatusHandler(value);
    });

    (this.editDSPForm.get('is_ssp_schain_source') as FormControl).valueChanges.subscribe(value => {
      this.editDspService.onChangeSSPSourceSchainStatusHandler(value);
    });

    (this.editDSPForm.get('video') as FormControl).valueChanges.subscribe(value => {
      this.editDspService.onChangeVideoFormatHandler(value);
    });

    (this.editDSPForm.get('rewarded') as FormControl).valueChanges.subscribe(value => {
      this.editDspService.onChangeRewardedVideoFormatHandler(value);
    });

    (this.editDSPForm.get('banner') as FormControl).valueChanges.subscribe(value => {
      this.editDspService.onChangeBannerFormatHandler(value);
    });

    (this.editDSPForm.get('native') as FormControl).valueChanges.subscribe(value => {
      this.editDspService.onChangeNativeHandler(value);
    });

    (this.editDSPForm.get('deviceIdRequired') as FormControl).valueChanges.subscribe(value => {
      this.editDspService.onChangeOnlyWithIFAHandler(value);
    });

    (this.editDSPForm.get('pixalate_pb_settings')?.get('ip') as FormControl).valueChanges.subscribe((value) => {
      this.editDspService.onChangePixalatePreBidIpHandler(value);
    });

    (this.editDSPForm.get('pixalate_pb_settings')?.get('ifa') as FormControl).valueChanges.subscribe((value) => {
      this.editDspService.onChangePixalatePreBidIFAHandler(value);
    });

    (this.editDSPForm.get('pixalate_pb_settings')?.get('hr_app') as FormControl).valueChanges.subscribe((value) => {
      this.editDspService.onChangePixalatePreBidBundleHandler(value);
    });

    (this.editDSPForm.get('schainCompany') as FormControl).valueChanges.subscribe((value) => {
      this.editDspService.onChangeSchainCompanyHandler(value);
    });

    (this.editDSPForm.get('schain_node_order') as FormControl).valueChanges.subscribe((value) => {
      if (value === null) {
        return;
      }

      this.editDspService.onChangeSchainNodeOrderHandler(value, this.customSchainSettingsModalWidth);
    });

    (this.editDSPForm.get('is_lmt_and_dnt_filter') as FormControl).valueChanges.subscribe((value) => {
      this.editDspService.onChangeLMTAndDNTFilterHandler(value);
    });

    (this.editDSPForm.get('presetPlayerSizes')?.get('size') as FormControl).valueChanges.subscribe((value) => {
      this.editDspService.onChangeVideoWidthPresetsHandler(value);
    });

    (this.editDSPForm.get('playerSizes')?.get('size') as FormControl).valueChanges.subscribe((value) => {
      this.editDspService.onChangeVideoSizesHandler(value);
    });

    (this.editDSPForm.get('is_only_with_consent') as FormControl).valueChanges.subscribe((value) => {
      this.editDspService.onShowConsentConfirmModalHandler(value);
    });
  }

  public ngAfterContentInit(): void {
    this.macrosListContentHeight = window.innerHeight - 200 + 'px';
    this.macrosListBodyHeight = window.innerHeight - 250 + 'px';
    this.customSchainSettingsModalWidth = window.innerWidth - 800 + 'px';
    window.addEventListener('resize', () => {
      this.macrosListContentHeight = window.innerHeight - 200 + 'px';
      this.macrosListBodyHeight = window.innerHeight - 250 + 'px';
      this.customSchainSettingsModalWidth = window.innerWidth - 800 + 'px';
    });
  }

  protected get isBotmanPostBidIsEnabled(): boolean {
    return this.editDspService.isBotmanPostBidIsEnabled();
  }

  protected isHumanFraudsensorEnabled(): boolean {
    return this.editDspService.isHumanFraudsensorEnabled();
  }

  protected isFraudLogixEnabled(): boolean {
    return this.editDspService.isFraudLogixEnabled();
  }


  protected get editDSPForm(): FormGroup {
    return this.editDspService.editDSPForm;
  }

  protected getDynamicNameForField(name: string | number): string {
    return name as string;
  }

  protected onChangeQPSAdapter(value: boolean): void {
    this.editDspService.onChangeQPSAdapterHandler(value);
  }

  protected isRequiredAdapterField(itemName: string): boolean {
    return this.editDspService.getIsRequiredAdapterField(itemName);
  }

  protected onChangeTab(event: number): void {
    this.editDspService.onChangeTabHandler(event);
  }

  protected onCompanyChange(): void {
    this.editDspService.onCompanyChangeHandler();
  }

  protected onAddCustomSize(input: HTMLInputElement, array: any[]) {
    this.editDspService.onAddCustomSizeHandler(input, array);
  }

  protected onValidateSize(event: KeyboardEvent): void {
    this.editDspService.onValidateSizeHandler(event);
  }

  protected onChangeRtbAdapterField(event: Event, field: string | number, name: string): void {
    this.editDspService.onChangeRtbAdapterFieldHandler(event, field, name);
  }

  protected onChangeCheckedTCF(value: boolean): void {
    this.editDspService.onChangeCheckedTCFHandler(value);
  }

  protected onChangePreBidServer(server: string | number): void {
    this.editDspService.onChangePreBidServerHandler(server);
  }

  protected onChangeCustomAdapter(server: number): void {
    this.editDspService.onChangeCustomAdapterHandler(server);
  }

  protected resolveAdapterFields() {
    this.editDspService.onResolveAdapterFieldsHandler();
  }

  protected onPreventInput(event: Event, field: string): void {
    this.editDspService.onPreventInputHandler(event, field);
  }

  protected getBlockedIPsCount(): number {
    return this.editDspService.getBlockedIPsCount();
  }

  protected isDisabledOption(adapterName: string): boolean {
    return this.editDspService.isDisabledOption(adapterName);
  }

  protected onChangeField(value: Event): void {
    this.editDspService.onChangeFieldHandler(value);
  }

  protected onFormSubmit(): void {
    this.editDspService.onFormSubmitHandler(() => this.dialogRef.close('updated'));
  }

  protected onCloseModal(): void {
    this.editDspService.onCloseModalHandler(() => this.dialogRef.close('cancel'));
  }

  protected editLists(type: string): void {
    this.editDspService.onEditBlockAllowItemsHandler(type);
  }

  protected onEndpointChange(event: Event): boolean {
    return this.editDspService.onEndpointChangeHandler(event);
  }

  protected showMacrosList(): void {
    this.editDspService.onShowMacrosListHandler(this.macrosListContentHeight, this.macrosListBodyHeight);
  }

  protected async onApiLinkTest(link: string, e: Event): Promise<void> {
    return await this.editDspService.onApiLinkTestHandler(link, e);
  }

  protected onLinkCopy(event: MouseEvent, label: string) {
    this.editDspService.onLinkCopyHandler(event, label);
  }

  protected onDeleteEndpoint(endpoint: PlatformInterface.IPlatformDSP) {
    this.editDspService.onDeleteEndpointHandler(endpoint, () => this.dialogRef.close('updated'));
  }

  protected onDuplicateEndpoint(endpointId: number): void {
    this.editDspService.onDuplicateEndpointHandler(endpointId, () => this.dialogRef.close('updated'));
  }

  protected onValidateLink(link: string, event: Event) {
    this.editDspService.onValidateLinkHandler(link, event);
  }

  protected getError(value: boolean): void {
    this.editDspService.getError(value);
  }

  protected onChangeNative(value: boolean): void {
    this.editDspService.onChangeNativeHandler(value);
  }

  protected botmanPreBidIsEnabled(): boolean {
    return this.editDspService.botmanPreBidIsEnabled();
  }

  protected onChangeSize(id: number): void {
    return this.editDspService.onChangeSizeHandler(id);
  }

  protected onChangeMarginType(type: string): void {
    this.editDspService.onChangeMarginTypeHandler(type);
  }

  protected onEndpointUrlTest(endpointUrl: string, event: MouseEvent): void {
    this.editDspService.onEndpointUrlTestHandler(endpointUrl, event);
  }

  protected getTooltipTitle(order: any): string {
    return `To activate this option, please fill in the "${order.name}" value for the selected Custom Schain in Custom Schain Settings. You'll be redirected to the edit screen to complete it. Saving the endpoint will not be possible until the required SID is added.`;
  }
}
